import React from 'react';

/**
 * Badge — small pill for categories, statuses, and advice chips.
 */
const VARIANTS = {
    neutral: 'bg-slate-100 dark:bg-slate-700 text-slate-600 dark:text-slate-300',
    brand: 'bg-brand-100 dark:bg-brand-900/40 text-brand-800 dark:text-brand-200',
    success: 'bg-brand-100 dark:bg-brand-900/40 text-brand-800 dark:text-brand-200',
    warn: 'bg-amber-100 dark:bg-amber-900/40 text-amber-800 dark:text-amber-200',
    danger: 'bg-red-100 dark:bg-red-900/40 text-red-800 dark:text-red-200',
};

export default function Badge({ variant = 'neutral', icon: Icon, className = '', children }) {
    const classes = [
        'inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium',
        VARIANTS[variant] || VARIANTS.neutral,
        className,
    ].filter(Boolean).join(' ');

    return (
        <span className={classes}>
            {Icon && <Icon size={12} className="mr-1.5" />}
            {children}
        </span>
    );
}
